import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux"; // Removed useSelector since otpSent and loading are not used
import {
  setError,
  setLoading,
  setUser,
  setOTPVerified,
  setOTPSent,
  logout,
} from "../../../features/common/authSlice";
import { loginWithPhone, login, verifyOTP } from "../../../services/userservice";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loginObj, setLoginObj] = useState({ email: "", password: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [otpSent, setOTPSent] = useState(false);

  const sendLoginHandler = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      dispatch(setLoading()); // Dispatch setLoading action
      const reqData = {
        email: loginObj.email, password: loginObj.password
      }
      const response = await login(reqData);
      const user = response?.data?.data;
      const authorizationHeader = response.headers.get("Authorization");
      const token = authorizationHeader?.split(" ")[1];

      if (token && user) {
        console.log("hello")
        dispatch(setUser({ token, user })); // Dispatch setUser action
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        navigate("/dashboard");
        window.location.reload();
      } else {
        throw new Error("Invalid response from server");
      }
      // const response = await loginWithPhone(loginObj.phone_no);
      // if (response.status === true) {
      //   setOTPSent(true); // Set OTP sent status to true
      // }
      // // dispatch(setOTPVerified(false)); // Reset OTP verification status
      // // dispatch(setOTPVerified(true)); // Dispatch action to update OTP sent status
    } catch (error) {
      console.log("error", error)
      setErrorMessage(error)
      dispatch(setError(error)); // Dispatch setError action
    }
  };


  //     e.preventDefault();
  //     setErrorMessage('');
  //     try {
  //         dispatch(setLoading()); // Dispatch setLoading action
  //         const response = await verifyOTP(loginObj.phone_no, Number(loginObj.otp));

  //         if (response?.status === 200 && response?.data?.status === true) {
  //             const user = response?.data?.data?.user;
  //             const authorizationHeader = response.headers.get('Authorization');
  //             const token = authorizationHeader?.split(' ')[1];

  //             if (token && user) {
  //                 dispatch(setOTPVerified(true)); // Dispatch action to update OTP verification status
  //                 dispatch(setUser({ token, user })); // Dispatch setUser action
  //                 localStorage.setItem('token', token);
  //                 localStorage.setItem('user', JSON.stringify(user));
  //                 navigate('/app/dashboard');
  //             } else {
  //                 throw new Error('Invalid response from server');
  //             }
  //         } else {
  //             throw new Error('OTP verification failed');
  //         }
  //     } catch (error) {
  //         dispatch(setError(error.message)); // Dispatch setError action
  //     }
  // };

  const verifyOTPHandler = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    try {
      dispatch(setLoading()); // Dispatch setLoading action

      const response = await verifyOTP(loginObj.phone_no, Number(loginObj.otp));
      const user = response?.data?.data?.user;
      const authorizationHeader = response.headers.get("Authorization");
      const token = authorizationHeader?.split(" ")[1];

      if (token && user) {

        dispatch(setUser({ token, user })); // Dispatch setUser action
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        navigate("/dashboard");
        window.location.reload();
      } else {
        throw new Error("Invalid response from server");
      }
    } catch (error) {
      dispatch(setError(error.message)); // Dispatch setError action
    } finally {
      dispatch(setLoading(false)); // Set loading to false after the operation completes
    }
  };


  const updateFormValue = (e) => {
    const { name, value } = e.target;
    setErrorMessage("");
    setLoginObj({ ...loginObj, [name]: value });
  };

  console.log(errorMessage)

  return (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div className="login-logo">
          <b>SWT Console</b>
        </div>
        <div className="card">
          <div className="card-body login-card-body">
            <p className="login-box-msg">Sign in</p>
            <form onSubmit={sendLoginHandler}>
              <div className="input-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  name="email"
                  value={loginObj.email}
                  onChange={updateFormValue}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  name="password"
                  value={loginObj.password}
                  onChange={updateFormValue}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>

              <button type="submit" className="btn mt-2 w-full btn-primary">
                Login
              </button>
            </form>

            {errorMessage && <div className="text-danger">{errorMessage}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
